import {
  AllOtherPerilsDeductible,
  CoverageAnimalLiabilityValue,
  CoverageDamageToPropertyOfOthersValue,
  CoverageDebrisRemovalValue,
  CoverageELiabilityValue,
  CoverageEquipmentBreakdownValue,
  CoverageFMedicalPaymentToOthersValue,
  CoverageFungiWetOrDryRotOrBacteriaPropertyValue,
  CoverageIdentityFraudExpenseValue,
  CoverageLossAssessmentValue,
  CoverageWaterBackupAndSumpOverflowValue,
  ResidenceBurglaryValue,
  WaterDamageDeductible,
  WindHailDeductible,
} from "@covertree/new-business-graphql";

export function mapDollarsEnumToNumber(
  enumValue?:
    | AllOtherPerilsDeductible
    | CoverageAnimalLiabilityValue
    | CoverageDamageToPropertyOfOthersValue
    | CoverageDebrisRemovalValue
    | CoverageELiabilityValue
    | CoverageEquipmentBreakdownValue
    | CoverageFMedicalPaymentToOthersValue
    | CoverageFungiWetOrDryRotOrBacteriaPropertyValue
    | CoverageIdentityFraudExpenseValue
    | CoverageLossAssessmentValue
    | CoverageWaterBackupAndSumpOverflowValue
    | ResidenceBurglaryValue
    | WaterDamageDeductible
    | WindHailDeductible
    | null
): string | number {
  switch (enumValue) {
    case AllOtherPerilsDeductible.Dollars500:
    case CoverageDamageToPropertyOfOthersValue.Dollars500:
    case CoverageFMedicalPaymentToOthersValue.Dollars500:
    case WindHailDeductible.Dollars500:
      return 500;
    case AllOtherPerilsDeductible.Dollars1K:
    case CoverageFMedicalPaymentToOthersValue.Dollars1K:
    case CoverageLossAssessmentValue.Dollars1K:
    case WindHailDeductible.Dollars1K:
      return 1000;
    case CoverageFMedicalPaymentToOthersValue.Dollars2K:
      return 2000;
    case AllOtherPerilsDeductible.Dollars2K500:
    case WaterDamageDeductible.Dollars2K500:
    case WindHailDeductible.Dollars2K500:
      return 2500;
    case CoverageFMedicalPaymentToOthersValue.Dollars3K:
      return 3000;
    case CoverageFungiWetOrDryRotOrBacteriaPropertyValue.Dollars3K500:
      return 3500;
    case CoverageFMedicalPaymentToOthersValue.Dollars4K:
      return 4000;
    case AllOtherPerilsDeductible.Dollars5K:
    case CoverageDebrisRemovalValue.Dollars5K:
    case CoverageLossAssessmentValue.Dollars5K:
    case CoverageWaterBackupAndSumpOverflowValue.Dollars5K:
    case ResidenceBurglaryValue.Dollars5K:
    case WaterDamageDeductible.Dollars5K:
    case WindHailDeductible.Dollars5K:
      return 5000;
    case AllOtherPerilsDeductible.Dollars10K:
    case CoverageAnimalLiabilityValue.Dollars10K:
    case CoverageDebrisRemovalValue.Dollars10K:
    case CoverageWaterBackupAndSumpOverflowValue.Dollars10K:
    case ResidenceBurglaryValue.Dollars10K:
    case WaterDamageDeductible.Dollars10K:
    case WindHailDeductible.Dollars10K:
      return 10000;
    case CoverageIdentityFraudExpenseValue.Dollars15K:
    case ResidenceBurglaryValue.Dollars15K:
      return 15000;
    case ResidenceBurglaryValue.Dollars20K:
      return 20000;
    case CoverageAnimalLiabilityValue.Dollars25K:
    case CoverageELiabilityValue.Dollars25K:
    case CoverageWaterBackupAndSumpOverflowValue.Dollars25K:
      return 25000;
    case ResidenceBurglaryValue.Dollars30K:
      return 30000;
    case ResidenceBurglaryValue.Dollars40K:
      return 40000;
    case CoverageAnimalLiabilityValue.Dollars50K:
    case CoverageELiabilityValue.Dollars50K:
    case ResidenceBurglaryValue.Dollars50K:
      return 50000;
    case CoverageAnimalLiabilityValue.Dollars100K:
    case CoverageELiabilityValue.Dollars100K:
    case CoverageEquipmentBreakdownValue.Dollars100K:
      return 100000;
    case CoverageAnimalLiabilityValue.Dollars300K:
    case CoverageELiabilityValue.Dollars300K:
      return 300000;
    case CoverageAnimalLiabilityValue.Dollars500K:
    case CoverageELiabilityValue.Dollars500K:
      return 500000;
    case CoverageAnimalLiabilityValue.Excluded:
      return 0;
    case CoverageIdentityFraudExpenseValue.Dollars15K:
      return 15000;
    default:
      return "Unknown";
  }
}
